import { ChevronRight, ExpandLess, ExpandMore } from '@mui/icons-material';
import {
  Box,
  Collapse,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from '@mui/material';
import { isEmpty } from 'lodash';
import React, { useEffect, useRef, useState } from 'react';
import { NavLink } from 'react-router-dom';
import '../AppSidebar.styles.css';
import { maskPath } from '../../shared/utils/utils';
import getNavIcon from './menu.icon';
import CanShow from '../../shared/components/CanShow';
import WBCONST from '../../shared/constants/wb.const';
import { getColors } from '../../theme';

const colors = getColors();

const NavLinkMui = React.forwardRef((props, forwardedRef) => (
  <NavLink {...props} ref={forwardedRef} />
));

function SideBarHoverExpanded({
  menu,
  open,
  setOpen,
  setExpand,
  expand,
  drawopen,
  setOpenSubMenuId,
  nestedMenuOpen,
  isExitFromNestedDrawer,
  setIsExitFromNestedDrawer,
}) {
  const { colorShades, text, primary } = colors;
  const { moduleName, icon, path, menus = [] } = menu;
  const multiLevelMenuRef = useRef();
  const isExpanded = expand === path;
  const [isDrawer, setDrawer] = useState(true);
  const [activeMenus, setActiveMenus] = useState([]);
  const { SIDEBAR_WIDTH } = WBCONST;

  const isChildActive = menu.menus.some((m) => {
    if (m.menuId === sessionStorage.getItem('subMenu1')) {
      return true;
    }
    return m.childMenu?.some((c) => {
      const cMenuId = sessionStorage.getItem('subMenu1');
      return c.menuId === cMenuId;
    });
  });

  const toggleCollapse = () => {
    setExpand(isExpanded ? null : path);
    setOpenSubMenuId(null);
  };

  const handleClickOutside = (e) => {
    if (multiLevelMenuRef.current && !multiLevelMenuRef.current.contains(e.target)) {
      if (!drawopen) {
        setDrawer(false);
      }
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  });

  useEffect(() => {
    if (isChildActive) setExpand(path);
  }, [isChildActive]);

  const getMaxSubMenuLevel = () => {
    let maxLevel = -1;
    const levels = Array.from({ length: sessionStorage.length }, (_, i) => sessionStorage.key(i))
      .filter((key) => key && key.startsWith('subMenu'))
      .map((key) => parseInt(key.slice(7), 10))
      .filter((level) => !Number.isNaN(level));

    if (levels.length > 0) {
      maxLevel = Math.max(...levels);
    }

    return maxLevel;
  };

  function getMenuWithChildren(inputArray, maxLevel, currentLevel = 1) {
    let result = [];
    if (currentLevel > maxLevel) {
      return result;
    }
    inputArray.forEach((m) => {
      const menuId = sessionStorage.getItem(`subMenu${currentLevel}`);
      if (m.menuId === menuId) {
        result.push(m);
        if (m.childMenu && m.childMenu.length > 0 && currentLevel < maxLevel) {
          m.childMenu.forEach((child) => {
            result = result.concat(getMenuWithChildren([child], maxLevel, currentLevel + 1));
          });
        }
      }
    });
    return result;
  }

  useEffect(() => {
    if (menu.menus.length > 0) {
      const maxLevel = getMaxSubMenuLevel();
      if (maxLevel > 0) {
        const result = getMenuWithChildren(menu.menus, maxLevel - 1);
        setActiveMenus(result);
        setDrawer(true);
      }
    }
  }, [nestedMenuOpen]);

  useEffect(() => {
    if (isExitFromNestedDrawer) {
      setDrawer(false);
      setIsExitFromNestedDrawer(false);
    }
  }, [isExitFromNestedDrawer]);

  const handleHover = () => {
    setDrawer(true);
  };
  const styleObj = {
    fontSize: 9,
    marginTop: '-6px',
    marginLeft: drawopen && '3px',
    color: text.sideBar,
  };

  const handleMenuClick = (submenu, le) => {
    setDrawer(true);
    if (submenu) {
      if (isEmpty(submenu.childMenu)) {
        setDrawer(false);
        Object.keys(sessionStorage).forEach((key) => {
          const match = key.match(/^subMenu(\d+)$/);
          if (match) {
            const menuLevel = parseInt(match[1], 10);
            if (menuLevel > le) {
              sessionStorage.removeItem(key);
            }
          }
        });
        sessionStorage.setItem(`subMenu${le}`, submenu?.menuId);
        if (drawopen) {
          setOpen(false);
        }
      }
      setActiveMenus((prev) => [...prev.slice(0, le - 1), submenu]);
    }
  };

  const renderMenuItems = (men, lev) =>
    men?.childMenu?.map((item, index) => (
      <ListItem
        className={`${
          sessionStorage.getItem(`subMenu${lev}`) === item?.menuId ? 'submenu-active' : null
        }`}
        key={item?.menuId}
        disablePadding
        sx={{ display: 'block' }}
      >
        <ListItemButton
          key={`${lev}-${index}`}
          onClick={() => handleMenuClick(item, lev)}
          component={item.screenPath ? NavLinkMui : 'div'}
          to={maskPath(item.screenPath)}
          selected={sessionStorage.getItem(`subMenu${lev}`) === item?.menuId}
          sx={{
            minHeight: 20,
            height: 18,
            justifyContent: open ? 'initial' : 'center',
            px: 2.5,
            py: 2.5,
          }}
        >
          <Tooltip title={item.caption} placement="right">
            <ListItemText
              primaryTypographyProps={{
                color: colorShades.greyShade,
                noWrap: true,
              }}
              primary={`${item.caption}`}
            />
          </Tooltip>
          {!isEmpty(item.childMenu) && <ChevronRight />}
        </ListItemButton>
      </ListItem>
    ));

  return (
    <ListItem disablePadding sx={{ display: 'block' }}>
      <ListItemButton
        className={`parent-menu ${isChildActive ? open && 'active' : ''} ${
          isChildActive ? !open && 'hactive' : ''
        }`}
        onClick={toggleCollapse}
        selected={isChildActive}
        onMouseEnter={handleHover}
        sx={{
          justifyContent: open ? 'initial' : 'center',
          px: !open ? 2.5 : 1,
          py: 0,
          paddingBottom: !open ? '15px' : '0px',
          textAlign: !open && 'center',
          height: !open && '60px',
          borderRadius: '0px 24px 24px 0px',
          marginRight: '12px',
          ':hover': {
            backgroundColor: primary.veryLightAlt,
          },
          '&.Mui-selected': {
            backgroundColor: primary.veryLightAlt,
          },
          '&.Mui-selected:hover': {
            backgroundColor: primary.veryLightAlt,
          },
        }}
      >
        <Box
          className="highlighter"
          sx={{
            width: 6,
            position: 'absolute',
            left: 0,
            height: 45,
            backgroundColor: primary.main,
            borderTopRightRadius: 5,
            borderBottomRightRadius: 5,
          }}
        />
        <ListItemIcon
          sx={{
            minWidth: 0,
            justifyContent: 'center',
            padding: !open ? '10px 20px' : '10px 0',
          }}
        >
          <Box>
            <Box sx={{ color: !open && text.accent, marginLeft: drawopen && '3px' }}>
              {getNavIcon(icon)}
            </Box>
            <p style={styleObj}>{!open && moduleName}</p>
          </Box>
        </ListItemIcon>
        <Tooltip title={moduleName} placement="right">
          <ListItemText
            primaryTypographyProps={{ color: colorShades.greyShade, noWrap: true, ml: 1 }}
            primary={open && moduleName}
          />
        </Tooltip>
        <CanShow show={open}>
          {isExpanded ? (
            <ExpandLess sx={{ color: text.secondary }} />
          ) : (
            <ExpandMore sx={{ color: text.secondary }} />
          )}
        </CanShow>
      </ListItemButton>
      <Collapse ref={multiLevelMenuRef} in={isExpanded} timeout="auto" unmountOnExit>
        {open && (
          <List sx={{ paddingY: '0px' }}>
            {menus.map((item, index) => {
              const isActive = sessionStorage.getItem('subMenu1') === item.menuId;
              return (
                <Tooltip title={item.caption} placement="right" key={item.menuId}>
                  <ListItemButton
                    component={!isEmpty(item.childMenu) ? 'div' : NavLinkMui}
                    {...(!isEmpty(item.childMenu) ? {} : { to: `${maskPath(item.screenPath)}` })}
                    className={`ListItemButton${isActive ? open && 'active' : ''} ${
                      isActive ? !open && 'hactive' : ''
                    }`}
                    key={`${0}-${index}`}
                    onClick={() => handleMenuClick(item, 1)}
                    sx={{
                      height: 40,
                      justifyContent: open ? 'initial' : 'center',
                      color: colorShades.greyShade,
                      ml: 1,
                      pl: 3,
                      pr: 1,
                      py: 0,
                      '&.active': {
                        background: 'none',
                      },
                    }}
                  >
                    <ListItemText primary={`${item.caption}`} />
                    {!isEmpty(item.childMenu) && <ChevronRight />}
                  </ListItemButton>
                </Tooltip>
              );
            })}
          </List>
        )}
        {!isEmpty(activeMenus) &&
          activeMenus
            .filter((submenu) => !isEmpty(submenu.childMenu))
            .map((submenu, level) => (
              <Drawer
                key={`${submenu.menuId || level}-${level}`}
                variant="persistent"
                anchor="left"
                open={isDrawer}
                sx={{
                  width: SIDEBAR_WIDTH,
                  flexShrink: 0,
                  top: 0,
                  position: 'fixed',
                  '& .MuiDrawer-paper': {
                    width: SIDEBAR_WIDTH,
                    boxSizing: 'border-box',
                    left: SIDEBAR_WIDTH * (level + 1),
                  },
                }}
                transitionDuration={0}
              >
                <List
                  sx={{
                    height: '100%',
                    width: SIDEBAR_WIDTH,
                    borderLeft: `0.6px solid ${colorShades.mediumGrey}`,
                    borderTop: `0.6px solid ${colorShades.mediumGrey}`,
                    borderRight: `0.6px solid ${colorShades.mediumGrey}`,
                    overflow: 'auto',
                    marginTop: '42px',
                    borderTopRightRadius: '10px',
                    backgroundColor: colorShades.pureWhite,
                  }}
                >
                  {renderMenuItems(submenu, level + 2)}
                </List>
              </Drawer>
            ))}
      </Collapse>
    </ListItem>
  );
}
export default SideBarHoverExpanded;
